import { LANDING_FAQ } from '../../content/landingFaq'
import { LandingSection } from './LandingSection'

export function LandingFaq() {
  return (
    <LandingSection
      id="faq"
      title="Frequently asked questions"
      subtitle="Quick answers about uptime monitoring, Slack alerts, and the free plan."
    >
      <dl className="mx-auto max-w-3xl divide-y divide-border-subtle">
        {LANDING_FAQ.map((item) => (
          <div key={item.question} className="py-5 first:pt-0 last:pb-0">
            <dt className="text-base font-semibold text-text-primary">{item.question}</dt>
            <dd className="mt-2 text-sm leading-relaxed text-text-secondary">{item.answer}</dd>
          </div>
        ))}
      </dl>
    </LandingSection>
  )
}
